import { tableHelper } from "@/helpers/table.helper";
import { getBlankRecord } from "./helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      providerId: null,
      data: [],
      expanded: [],
      paging: tableHelper.getDefaultPaging("VslStatus,HelpStatus,Surname,FirstName", true),
      loading: false,
      loaded: false
    },
    flagPrimary: {
      saving: false
    },
    changeStatus: {
      contactId: null,
      loading: false,
      loaded: false,
      saving: false,
      data: getBlankRecord()
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    changeStatus: {
      loaded: false
    }
  };
}
